import { EstimateFormSlug } from "config";

/*
..................
~~~ INTERFACES ~~~
..................
*/

export interface IFlow {
  id: string;
  name: string;
  slug: FlowTypes;
  terminalBehavior: FlowTerminalBehaviorType;
}

export interface IFlowSession {
  id: string;
}

/*
..................
~~~~~ ENUMS ~~~~~
..................
*/

export const EnumFlowTypes = {
  "account-profile": "account-profile",
  beneficiary: "beneficiary",
  "cdd-form": "cdd-form",
  "coverage-adjustment": "coverage-adjustment",
  "referral-partner": "referral-partner",
  "estimate-form": "estimate-form",
  "ineligibility-warning": "ineligibility-warning",
  "interview-question": "interview-question",
  "insurance-profile": "insurance-profile",
  "onboarding-intro": "onboarding-intro",
  "post-underwriting": "post-underwriting",
  "pre-underwriting": "pre-underwriting",
  "pre-verified-initial-data": "pre-verified-initial-data",
  "purchase-policy": "purchase-policy",
  "quote-review": "quote-review",
  "replacement-cooldown": "replacement-cooldown",
  "term-life-extension": "term-life-extension",
  "underwriting-evidence": "underwriting-evidence",
  "underwriting-interview": "underwriting-interview",
} as const;

/*
..................
~~~~~ TYPES ~~~~~
..................
*/

export type EnumFlowTypes = (typeof EnumFlowTypes)[keyof typeof EnumFlowTypes];
export type FlowTypes = keyof typeof EnumFlowTypes | typeof EstimateFormSlug;

type FlowTerminalBehaviorType = "before_response" | "after_response";
